import type { EarningsCalendarItem } from "@/lib/earnings-calendar/types";
import type { VerificationStatus } from "./types";

export function calendarItemVerification(item: EarningsCalendarItem): VerificationStatus {
  if (item.id.startsWith("verified-")) {
    return "verified";
  }
  if (
    item.sourceUrl &&
    item.sourceType !== "secondary" &&
    item.status !== "to_verify" &&
    item.reportPeriod !== "Other"
  ) {
    return "supported";
  }
  return "needs_review";
}

export function canPublishVerification(status: VerificationStatus) {
  return status === "verified" || status === "supported";
}
